import styled from 'styled-components';

import { OnboardingStyle } from '../../../public/onboarding/onboarding-style';
import { theme } from '../../../../global-styles/colors';

export const InOurWayStyle = styled.div`
  ${OnboardingStyle} {
    min-height: calc(100vh - 180px);
  }

  .success-next-btn {
    pointer-events: auto !important;
    cursor: pointer !important;
    margin: 25px 0;
    & > * {
      pointer-events: auto !important;
      cursor: pointer !important;
    }
  }
  margin-top: 62px;
  .success-img {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: auto;
    }
  }
  .in-our-way-text {
    margin-top: 85px;
  }
  .success-text {
    span,
    a {
      color: ${theme.primary.primary50};
    }
    p {
      text-align: center;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`;
